/**
 * Shared by paid search cards and the seller's appearance preview. Design (2026-10): a light green
 * background only, no border, ring or shadow. The 9px padding is what makes it read as a frame;
 * `ProductCard` pulls it back out with `-m-[9px]` so the card's content stays on the grid.
 */
export const PROMOTION_FRAME_CLASS =
  "relative rounded-lg bg-flavour-100 p-[9px]";
/** The My ads thumbnail version: a soft green halo instead of the old brand-green ring. */
export const PROMOTION_THUMBNAIL_CLASS = "ring-4 ring-flavour-200";
